import { clearCustomerSession } from "api";
import Button from "components/common/Button/Button";
import Divider from "components/common/Divider";
import Text from "components/common/Text/Text";
import Widget from "components/common/Widget";
import * as React from "react";
import { ApolloConsumer } from "react-apollo";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import { load } from "utils/ConfigLoader";

interface IProps {
  purchasedCategoryListDescription: string;
  onDone?(): void;
}

const OrderSummary = ({ purchasedCategoryListDescription, onDone }: IProps) => (
  <React.Fragment>
    <Row justify="center" align="center">
      <Col>
        <Text h3 center fullWidth>
          ORDER SUMMARY
        </Text>
        <br />
        <Divider />
        <Row justify="between">
          <Col align="left">
            <Text alternate>{purchasedCategoryListDescription}</Text>
          </Col>
          <Col align="right">
            <Text>Total:</Text>
            {"   "}
            <Text alternate>{load("purchase.totalPrice")}</Text>
          </Col>
        </Row>
        <Divider />
      </Col>
    </Row>
    <Row>
      <Col align="center">
        <br />
        <br />
        <Link to="/">
          <Button primary wide onClick={onDone}>
            I'm Done
          </Button>
        </Link>
      </Col>
    </Row>
  </React.Fragment>
);

export default (props: IProps) => (
  <ApolloConsumer>
    {client => {
      const onDone = () => clearCustomerSession(client);
      return <OrderSummary onDone={onDone} {...props} />;
    }}
  </ApolloConsumer>
);



// WEBPACK FOOTER //
// ./src/screens/PurchaseComplete/OrderSummary.tsx